export default "__VITE_PUBLIC_ASSET__04086eb8__"